module.exports = __webpack_public_path__ + "static/media/CriminalLaw.af8e779e.jpg";